export default function getBedbankPropertyIdFromSearchItem(searchItem: App.SearchItem | undefined): string | undefined {
  const bedbankPrefix = 'bedbank:'
  return searchItem?.searchType === 'property' && searchItem.value.startsWith(bedbankPrefix) ?
    searchItem.value.substring(bedbankPrefix.length) || undefined :
    undefined
}
